import useSWR from 'swr';
import { get, isEmpty } from 'lodash';

import { fetcher } from 'util/Api';

function useInvitation(key) {
  const { data, error } = useSWR(`/api/v1/invitations?key=${key}`, fetcher);
  const invitation = get(data, 'data', {});
  return {
    invitation,
    loading: !error && isEmpty(invitation),
    error,
  };
}

export default useInvitation;
